import React from "react";

// @mui
import {
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  AlertTitle,
  Stack,
} from "@mui/material";

import { hasError, formatError } from "../../utils/formatError";

import i18n from "../../i18n";
import Fields from "../editors";
import { AppDataContext } from "../../context/Context";
import { LoadingButton } from "@mui/lab";
import FormDialog from "../../components/dialogs/FormDialog";

export default class UpdateProfileDialog extends React.Component {
  onClose = () => {};
  Head;

  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: props.dialogOpen || false,
      dialogData: props.dialogData,
      alertText: props.alertText,
      alertTitle: props.alertTitle,
      loading: false,
    };

    this.onClose = props.onClose;
    this.Head = props.Head;
  }

  static getDerivedStateFromProps(props, state) {
    if (
      props.dialogOpen !== state.dialogOpen ||
      props.dialogData !== state.dialogData
    ) {
      return {
        dialogOpen: props.dialogOpen,
        alertText: props.alertText,
        alertTitle: props.alertTitle,
        dialogData: props.dialogData,
        loading: false,
      };
    }

    return null;
  }

  static contextType = AppDataContext;

  handleUpdateProfileDialogSave(event) {
    this.setState({ loading: true });

    const server = this.context.getState().server;

    server.users.updateProfile(this.state.dialogData).then((result) => {
      if (!hasError(result)) {
        this.setState({ loading: false });
        this.onClose();
      } else {
        this.setState({ loading: false });
        this.setState({ alertText: formatError(result) });
      }
    });
  }

  handleProfileValueChanged(id, value) {
    let dialogData = this.state.dialogData;
    dialogData[id] = value;
    this.setState({ dialogData: dialogData });
  }

  render() {
    let data = this.state.dialogData || {};
    return (
      <FormDialog
        open={this.state.dialogOpen}
        onClose={() => this.onClose()}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{i18n.t("text.updateProfile")}</DialogTitle>
        <DialogContent dividers>
          {this.state.alertText && (
            <Alert severity="error">
              <AlertTitle>{i18n.t("text.error")}</AlertTitle>
              {this.state.alertText}
            </Alert>
          )}

          {/* Spacing is the container's job (as in DialogAbstract):
                        the fields carry no margin of their own, so without
                        this they sat flush against each other. */}
          <Stack spacing={2.5}>
            {this.Head.map((field) => {
              let Field = Fields[field.cell];
              if (!Field) Field = Fields.Text; // fallback to text
              return (
                <Field
                  key={field.id}
                  field={field}
                  value={data[field.id]}
                  onChange={(id, value) =>
                    this.handleProfileValueChanged(id, value)
                  }
                />
              );
            })}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            color="inherit"
            disabled={this.state.loading}
            onClick={(event) => this.onClose()}
          >
            {i18n.t("buttons.cancel")}
          </Button>
          <LoadingButton
            variant="contained"
            loading={this.state.loading}
            onClick={(event) => this.handleUpdateProfileDialogSave(event)}
          >
            {i18n.t("buttons.save")}
          </LoadingButton>
        </DialogActions>
      </FormDialog>
    );
  }
}
